module.exports = __webpack_public_path__ + "static/media/20x20.d1266395.png";